// extracted by mini-css-extract-plugin
export default {"article":"SgIhR","poster":"ErWxn","cnImage":"U099q","categoryTitle":"MGrId","articleTitle":"VwGs3"};